import { SITE_NAME, absoluteUrl } from '@/lib/config';

/**
 * `WebSite` with a sitelinks search box: a search for `term` is `/shop?q=term`. The page carrying it
 * is the home page of the language on screen (`inLanguage` is added by `<Seo>`).
 */
export function websiteJsonLd(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: absoluteUrl('/'),
    description: 'Granite slabs, tiles and countertops from Rajsamand, Rajasthan, India.',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        // `{search_term_string}` is the placeholder schema.org defines: it must stay un-encoded
        urlTemplate: `${absoluteUrl('/shop')}?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };
}
